@if (selectedCp) {
  <div class="cp-selector-container">
    <div class="cp-selector">
      <div class="cp-number">{{ selectedCp?.cpNumber || 'Unnamed CP' }}</div>
      <div class="cp-meta">
        @if (selectedCp.system) {
          <span class="system">{{ selectedCp.system.name }}</span>
        }
        @if (selectedCp.subSystem) {
          <span class="subsystem"> — {{ selectedCp.subSystem.name }}</span>
        }
      </div>
    </div>
    @if (editMode) {
      <div class="cp-actions">
        <button mat-icon-button (click)="editCp()" matTooltip="Change CP" aria-label="Change commissioning package">
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="removeCp()"
          [disabled]="isCurrentCpSelected"
          [matTooltip]="isCurrentCpSelected ? 'Cannot remove current CP' : 'Remove CP'"
          aria-label="Remove commissioning package"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
  @if (documentNode.comments?.length > 0) {
    @for (comment of documentNode.comments; track comment) {
      <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
    }
  }
} @else {
  <div class="no-cp">
    <span>No CP selected</span>
    @if (editMode) {
      <button mat-icon-button class="cp-add-btn" (click)="editCp()" matTooltip="Select CP" aria-label="Select commissioning package">
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
}
